module.exports = __webpack_public_path__ + "static/media/book.f7c39058.svg";